import { getGridStringOperators } from '@mui/x-data-grid-pro';

export const getStringOperators = () => {
	return getGridStringOperators().filter(
		operator => operator.value !== 'isEmpty' && operator.value !== 'isNotEmpty' && operator.value !== 'isAnyOf',
	);
};
